import initialState from './initialState';
import { ActionType } from './action';

function subscribersReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ActionType.SET_IS_LOADING_SUBSCRIBE:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    case ActionType.SET_IS_SUCCESS_SUBSCRIBE:
      return {
        ...state,
        isSuccess: action.payload.isSuccess,
      };
    case ActionType.SET_IS_ERROR_SUBSCRIBER:
      return {
        ...state,
        isError: action.payload.isError,
      };
    default:
      return state;
  }
}

export default subscribersReducer;
